import { render, staticRenderFns } from "./NeList.vue?vue&type=template&id=49f705c7&scoped=true&"
import script from "./NeList.vue?vue&type=script&lang=js&"
export * from "./NeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f705c7",
  null
  
)

export default component.exports